import wixWindow from "wix-window";
import wixLocation from 'wix-location';
import { routeToLink } from "public/routes-links-map";
import { trackClickEvent } from "public/bi";

$w.onReady(function () {

    const currentPath = wixLocation.path[0];
    // if (currentPath.includes('knowledge-management')) {
    //     if (!$w('#kmNavLinks').isVisible) {
    //         $w('#kmNavLinks').show()
    //             .then(() => $w('#kmNavLinks').expand())
    //     }
        
    // } else {
    //     if ($w('#kmNavLinks').isVisible) {
    //         $w('#kmNavLinks').hide()
    //             .then(() => $w('#kmNavLinks').collapse())
    //     }
    // }
    const activeLink = routeToLink(currentPath) || 'home';
    $w('#waNavLinks').setAttribute('currentpagelinkfolder', activeLink);

    if(wixWindow.formFactor === "Mobile"){
		if (!$w('#button141').isVisible) {
            $w('#button141').show()
        }
    }

});

const hideAnnouncementBar = () => {
    $w('#announcementBar').collapse()
        .then(() => $w('#announcementBar').hide())
}

export function closeBarBtn_click(event) {
    hideAnnouncementBar();
}

// let currentNavLink = "";

// const FADE_IN_OPTIONS = {
//     duration: 100,
//     delay: 0
// };
// const FADE_OUT_OPTIONS = {
//     duration: 0,
//     delay: 0
// };

// const FADE_TIMEOUT = 200;

// const hideContainers = () => {
//   $w('#navContainerExplore, #navContainerPlatform, #navContainerWhyanswers').hide();
// }

// export function navLinkWhyanswers_mouseIn(event) {
//     currentNavLink = "whyAnsers";
//     $w('#navContainerExplore, #navContainerPlatform, #navContainerWhyanswers, #navContainerSolutions').hide('fade', FADE_OUT_OPTIONS)
//         .then(() => {
//             setTimeout(() => {
//                 if (currentNavLink === "whyAnsers") $w('#navContainerWhyanswers').show('fade', FADE_IN_OPTIONS)
//             }, 100)
//         })
// }

// export function navLinkPlatform_mouseIn(event) {
//     currentNavLink = "platform";
//     $w('#navContainerExplore, #navContainerPlatform, #navContainerWhyanswers, #navContainerSolutions').hide('fade', FADE_OUT_OPTIONS)
//         .then(() => {
//             setTimeout(() => {
//                 if (currentNavLink === "platform") $w('#navContainerPlatform').show('fade', FADE_IN_OPTIONS)
//             }, 100)
//         })
// }

// export function navLinkExplore_mouseIn(event) {
//     currentNavLink = "explore";
//     $w('#navContainerExplore, #navContainerPlatform, #navContainerWhyanswers, #navContainerSolutions').hide('fade', FADE_OUT_OPTIONS)
//         .then(() => {
//             setTimeout(() => {
//                 if (currentNavLink === "explore") $w('#navContainerExplore').show('fade', FADE_IN_OPTIONS)
//             }, 100)
//         })
// }

// export function navLinkSolutions_mouseIn(event) {
//     currentNavLink = "solutions";
//     $w('#navContainerExplore, #navContainerPlatform, #navContainerWhyanswers, #navContainerSolutions').hide('fade', FADE_OUT_OPTIONS)
//         .then(() => {
//             setTimeout(() => {
//                 if (currentNavLink === "solutions") $w('#navContainerSolutions').show('fade', FADE_IN_OPTIONS)
//             }, 100)
//         })
// }

// export function navBoxWhyanswers_mouseOut(event) {
//     $w('#navContainerWhyanswers').hide('fade', FADE_OUT_OPTIONS);
// }

// export function navBoxExplore_mouseOut(event) {
//     currentNavLink = "";
//     $w('#navContainerExplore').hide('fade', FADE_OUT_OPTIONS);
// }

// export function navBoxPlatform_mouseOut(event) {
//     currentNavLink = "";
//     $w('#navContainerPlatform').hide('fade', FADE_OUT_OPTIONS);
// }

// export function navBoxSolutions_mouseOut(event) {
//     currentNavLink = "";
//     $w('#navContainerSolutions').hide('fade', FADE_OUT_OPTIONS);
// }

// export function page1_mouseIn(event) {
//     currentNavLink = "";
//     $w('#navContainerExplore, #navContainerPlatform, #navContainerWhyanswers, #navContainerSolutions').hide();
// }

// export function navLinkWhyanswers_mouseOut(event) {

//     currentNavLink = "";
//     setTimeout(() => {
//         if (currentNavLink !== "whyAnswers") $w('#navContainerExplore, #navContainerPlatform, #navContainerWhyanswers, #navContainerSolutions').hide('fade', FADE_OUT_OPTIONS)
//     }, 100)

// }

// export function navLinkPlatform_mouseOut(event) {

//     currentNavLink = "";
//     setTimeout(() => {
//         if (currentNavLink !== "platform") $w('#navContainerExplore, #navContainerPlatform, #navContainerWhyanswers, #navContainerSolutions').hide('fade', FADE_OUT_OPTIONS)
//     }, 100)
// }

// export function navLinkExplore_mouseOut(event) {

//     currentNavLink = "";
//     setTimeout(() => {
//         if (currentNavLink !== "explore") $w('#navContainerExplore, #navContainerPlatform, #navContainerWhyanswers, #navContainerSolutions').hide('fade', FADE_OUT_OPTIONS)
//     }, 100)
// }

// export function navLinkSolutions_mouseOut(event) {

//     currentNavLink = "";
//     setTimeout(() => {
//         if (currentNavLink !== "solutions") $w('#navContainerExplore, #navContainerPlatform, #navContainerWhyanswers, #navContainerSolutions').hide('fade', FADE_OUT_OPTIONS)
//     }, 100)
// }

// export function navBoxWhyanswers_mouseIn(event) {
//     currentNavLink = "whyAnswers";
// }

// export function navBoxPlatform_mouseIn(event) {
//     currentNavLink = "platform";
// }

// export function navBoxExplore_mouseIn(event) {
//     currentNavLink = "explore";
// }

// export function navBoxSolutions_mouseIn(event) {
//     currentNavLink = "solutions";
// }

// export function navLinkHowdifferent_click(event) {
//     trackClickEvent(event.target, 'https://www.wixanswers.com/why-answers');
// }

// export function navLinkCustomers_click(event) {
//     trackClickEvent(event.target, 'https://www.wixanswers.com/customers')
// }

// export function navLinkKb_click(event) {
//     trackClickEvent(event.target, 'https://www.wixanswers.com/knowledge-management')
// }

// export function navLinkTicketing_click(event) {
//     trackClickEvent(event.target, 'https://www.wixanswers.com/ticketing-system')
// }

// export function navLinkCallcenter_click(event) {
//     trackClickEvent(event.target, 'https://www.wixanswers.com/call-center-software')
// }

// export function navLinkChat_click(event) {
//     trackClickEvent(event.target, 'https://www.wixanswers.com/live-chat-software')
// }

// export function navLinkWidget_click(event) {
//     trackClickEvent(event.target, 'https://www.wixanswers.com/help-widget')
// }

// export function navLinkInsights_click(event) {
//     trackClickEvent(event.target, 'https://www.wixanswers.com/insights')
// }

// export function navLinkWalkthrough_click(event) {
// 	trackClickEvent(event.target, 'https://info.wixanswers.com/unified_product_demo')
// }

// export function navLinkCxLibrary_click(event) {
//     trackClickEvent(event.target, 'https://www.wixanswers.com/cx-library')
// }

// export function navLinkBlog_click(event) {
//     trackClickEvent(event.target, 'https://www.wixanswers.com/blog')
// }

// export function navLinkHelpcenter_click(event) {
//     trackClickEvent(event.target, 'https://help.wixanswers.com/kb/en')
// }

// export function navLinkVideotutorial_click(event) {
//     trackClickEvent(event.target, 'https://www.wixanswers.com/video-tutorials')
// }

// export function navLinkDevtools_click(event) {
//     trackClickEvent(event.target, 'https://www.wixanswers.com/developers')
// }

// export function nkmLinkOverview_click(event) {
//     trackClickEvent(event.target, 'https://www.wixanswers.com/knowledge-management')
// }

// export function kmLinkUseCases_click(event) {
//     trackClickEvent(event.target, 'https://www.wixanswers.com/knowledge-management-use-cases')
// }

// export function kmLinkFeatures_click(event) {
//     trackClickEvent(event.target, 'https://www.wixanswers.com/knowledge-management-features')
// }

// // export function announcementBarText_click(event) {
// //     trackClickEvent(event.target, 'https://app.wixanswers.com/assessment')
// // }

// export function navLinkPricing_click(event) {
//     trackClickEvent(event.target, 'https://www.wixanswers.com/pricing')
// }

export function navLinkLogin_click(event) {
    trackClickEvent(event.target, 'https://app.wixanswers.com/login')
}

export function navLinkRequestdemo_click(event) {
    trackClickEvent(event.target, 'https://info.wixanswers.com/request-demo.html')
}

export function navLinkTryforfree_click(event) {
    trackClickEvent(event.target, 'https://app.wixanswers.com/signup')
}

export function navLogo_click(event) {
    trackClickEvent(event.target, 'https://www.wixanswers.com/')
}

// export function navLinkIntegrations_click(event) {
//     trackClickEvent(event.target, 'https://www.wixanswers.com/integrations')
// }

// export function navLinkCsSolution2021_click(event) {
//     trackClickEvent(event.target, 'https://www.wixanswers.com/future-of-customer-support')
// }

// export function navLinkCsSolution_click(event) {
//     // trackClickEvent(event.target, 'https://www.wixanswers.com/integrations')
// }
// export function navLinkTopIssues_click(event) {
//     trackClickEvent(event.target, 'https://www.wixanswers.com/top-issues')
// }
// export function navLinkControlRoom_click(event) {
//     trackClickEvent(event.target, 'https://www.wixanswers.com/control-room')
// }
// export function navLinkFullPlatform_click(event) {
//     trackClickEvent(event.target, 'https://www.wixanswers.com/full-platform');
// }
// export function navLinkCast_click(event) {
//     trackClickEvent(event.target, 'https://www.wixanswers.com/csat');
// }
// export function navLinkTa_click(event) {
//     trackClickEvent(event.target, 'https://app.wixanswers.com/assessment');
// }
// export function navLinkSpotter_click(event) {
// 	trackClickEvent(event.target, 'https://www.wixanswers.com/spotter-automations');
// }

// export function navLinkResults_click(event) {
// 	trackClickEvent(event.target, 'https://www.wixanswers.com/results-with-answers'); 
// }

// export function navLinkCxSmb_click(event) {
// 	trackClickEvent(event.target, 'https://www.wixanswers.com/smb');
// }

// export function navLinkCxEnterprise_click(event) {
// 	trackClickEvent(event.target, 'https://www.wixanswers.com/enterprise');
// }